import { forwardRef } from "react";
import type { AppIcon } from "../types";

export const USFlagIcon = forwardRef<SVGSVGElement, AppIcon>(
  ({ width = 16, height = 12, ...props }, ref) => {
    return (
      <svg
        ref={ref}
        width={width}
        height={height}
        viewBox="0 0 16 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H16V12H0V0Z"
          fill="url(#paint0_linear_11540_194578)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H16V0.8H0V0ZM0 1.6H16V2.4H0V1.6ZM0 3.2H16V4H0V3.2ZM0 4.8H16V5.6H0V4.8ZM0 6.4H16V7.2H0V6.4ZM0 8H16V8.8H0V8ZM0 9.6H16V10.4H0V9.6ZM0 11.2H16V12H0V11.2Z"
          fill="url(#paint1_linear_11540_194578)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 0H6.85714V5.6H0V0Z"
          fill="url(#paint2_linear_11540_194578)"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.14292 1.60029C0.932521 1.60029 0.761963 1.42121 0.761963 1.20029C0.761963 0.979379 0.932521 0.800293 1.14292 0.800293C1.35331 0.800293 1.52387 0.979379 1.52387 1.20029C1.52387 1.42121 1.35331 1.60029 1.14292 1.60029ZM2.66672 1.60029C2.45633 1.60029 2.28577 1.42121 2.28577 1.20029C2.28577 0.979379 2.45633 0.800293 2.66672 0.800293C2.87712 0.800293 3.04768 0.979379 3.04768 1.20029C3.04768 1.42121 2.87712 1.60029 2.66672 1.60029ZM4.19053 1.60029C3.98014 1.60029 3.80958 1.42121 3.80958 1.20029C3.80958 0.979379 3.98014 0.800293 4.19053 0.800293C4.40093 0.800293 4.57149 0.979379 4.57149 1.20029C4.57149 1.42121 4.40093 1.60029 4.19053 1.60029ZM5.71434 1.60029C5.50395 1.60029 5.33339 1.42121 5.33339 1.20029C5.33339 0.979379 5.50395 0.800293 5.71434 0.800293C5.92474 0.800293 6.0953 0.979379 6.0953 1.20029C6.0953 1.42121 5.92474 1.60029 5.71434 1.60029ZM1.90482 2.40029C1.69443 2.40029 1.52387 2.22121 1.52387 2.00029C1.52387 1.77938 1.69443 1.60029 1.90482 1.60029C2.11521 1.60029 2.28577 1.77938 2.28577 2.00029C2.28577 2.22121 2.11521 2.40029 1.90482 2.40029ZM3.42863 2.40029C3.21824 2.40029 3.04768 2.22121 3.04768 2.00029C3.04768 1.77938 3.21824 1.60029 3.42863 1.60029C3.63902 1.60029 3.80958 1.77938 3.80958 2.00029C3.80958 2.22121 3.63902 2.40029 3.42863 2.40029ZM4.95244 2.40029C4.74204 2.40029 4.57149 2.22121 4.57149 2.00029C4.57149 1.77938 4.74204 1.60029 4.95244 1.60029C5.16283 1.60029 5.33339 1.77938 5.33339 2.00029C5.33339 2.22121 5.16283 2.40029 4.95244 2.40029ZM5.71434 3.20029C5.50395 3.20029 5.33339 3.02121 5.33339 2.80029C5.33339 2.57938 5.50395 2.40029 5.71434 2.40029C5.92474 2.40029 6.0953 2.57938 6.0953 2.80029C6.0953 3.02121 5.92474 3.20029 5.71434 3.20029ZM4.19053 3.20029C3.98014 3.20029 3.80958 3.02121 3.80958 2.80029C3.80958 2.57938 3.98014 2.40029 4.19053 2.40029C4.40093 2.40029 4.57149 2.57938 4.57149 2.80029C4.57149 3.02121 4.40093 3.20029 4.19053 3.20029ZM2.66672 3.20029C2.45633 3.20029 2.28577 3.02121 2.28577 2.80029C2.28577 2.57938 2.45633 2.40029 2.66672 2.40029C2.87712 2.40029 3.04768 2.57938 3.04768 2.80029C3.04768 3.02121 2.87712 3.20029 2.66672 3.20029ZM1.14292 3.20029C0.932521 3.20029 0.761963 3.02121 0.761963 2.80029C0.761963 2.57938 0.932521 2.40029 1.14292 2.40029C1.35331 2.40029 1.52387 2.57938 1.52387 2.80029C1.52387 3.02121 1.35331 3.20029 1.14292 3.20029ZM1.90482 4.00029C1.69443 4.00029 1.52387 3.82121 1.52387 3.60029C1.52387 3.37938 1.69443 3.20029 1.90482 3.20029C2.11521 3.20029 2.28577 3.37938 2.28577 3.60029C2.28577 3.82121 2.11521 4.00029 1.90482 4.00029ZM3.42863 4.00029C3.21824 4.00029 3.04768 3.82121 3.04768 3.60029C3.04768 3.37938 3.21824 3.20029 3.42863 3.20029C3.63902 3.20029 3.80958 3.37938 3.80958 3.60029C3.80958 3.82121 3.63902 4.00029 3.42863 4.00029ZM4.95244 4.00029C4.74204 4.00029 4.57149 3.82121 4.57149 3.60029C4.57149 3.37938 4.74204 3.20029 4.95244 3.20029C5.16283 3.20029 5.33339 3.37938 5.33339 3.60029C5.33339 3.82121 5.16283 4.00029 4.95244 4.00029ZM5.71434 4.80029C5.50395 4.80029 5.33339 4.62121 5.33339 4.40029C5.33339 4.17938 5.50395 4.00029 5.71434 4.00029C5.92474 4.00029 6.0953 4.17938 6.0953 4.40029C6.0953 4.62121 5.92474 4.80029 5.71434 4.80029ZM4.19053 4.80029C3.98014 4.80029 3.80958 4.62121 3.80958 4.40029C3.80958 4.17938 3.98014 4.00029 4.19053 4.00029C4.40093 4.00029 4.57149 4.17938 4.57149 4.40029C4.57149 4.62121 4.40093 4.80029 4.19053 4.80029ZM2.66672 4.80029C2.45633 4.80029 2.28577 4.62121 2.28577 4.40029C2.28577 4.17938 2.45633 4.00029 2.66672 4.00029C2.87712 4.00029 3.04768 4.17938 3.04768 4.40029C3.04768 4.62121 2.87712 4.80029 2.66672 4.80029ZM1.14292 4.80029C0.932521 4.80029 0.761963 4.62121 0.761963 4.40029C0.761963 4.17938 0.932521 4.00029 1.14292 4.00029C1.35331 4.00029 1.52387 4.17938 1.52387 4.40029C1.52387 4.62121 1.35331 4.80029 1.14292 4.80029Z"
          fill="url(#paint3_linear_11540_194578)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_11540_194578"
            x1="168"
            y1="0"
            x2="168"
            y2="180"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#F0F0F0" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_11540_194578"
            x1="168"
            y1="0"
            x2="168"
            y2="180"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#D02F44" />
            <stop offset="1" stopColor="#B12537" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_11540_194578"
            x1="72"
            y1="0"
            x2="72"
            y2="84"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#46467F" />
            <stop offset="1" stopColor="#3C3C6D" />
          </linearGradient>
          <linearGradient
            id="paint3_linear_11540_194578"
            x1="56.762"
            y1="0.800293"
            x2="56.762"
            y2="60.8003"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="white" />
            <stop offset="1" stopColor="#F0F0F0" />
          </linearGradient>
        </defs>
      </svg>
    );
  },
);
